import styled from 'styled-components';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: ${SIZES['8']} ${SIZES['16']} 0 ${SIZES['16']};
`;

const ImageContainer = styled.div<{borderColor?: string}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${SIZES['1']} solid ${props => props.borderColor ?? COLORS.darkGrey};
  border-radius: ${SIZES['34']};
  min-width: ${SIZES['68']};
  height: ${SIZES['68']};
`;

const DeactivateableTypography = styled(Typography)<{deactivated?: boolean}>`
  &&& {
    ${props =>
      props.deactivated &&
      `
    color: ${COLORS.darkGrey};
  `}
  }
`;

export {Container, ImageContainer, DeactivateableTypography};
